/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_RealcityInputs */

const cs_enum_realcity = /** @type {(inputs: Enum_RealcityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realcity`)
};

const en_enum_realcity = /** @type {(inputs: Enum_RealcityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realcity`)
};

/**
* | output |
* | --- |
* | "Realcity" |
*
* @param {Enum_RealcityInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const enum_realcity = /** @type {((inputs?: Enum_RealcityInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_RealcityInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_realcity(inputs)
	return cs_enum_realcity(inputs)
});